// ── 계약 등록 창 설정 — 오른쪽 미리보기 ──────────────────────────────────────
// 실제 계약 모달이 쓰는 **바로 그 섹션 부품**을 그대로 렌더한다. 흉내 낸 그림이 아니라서
//   설정을 바꾸면 진짜 창과 똑같이 바뀐다. 입력은 전부 먹통(readOnly 취급) — 저장되지 않는다.
import React, { useMemo } from 'react';
import { ContractModalSections } from './ContractModalBody';
import { inputStyle } from './modalStyles';

const noop = () => {};

export function ContractFieldPreview({ config, ticketTypes = [] }) {
  const isNew = true;   // 계약 등록 창 기준으로만 보여준다
  // 값은 전부 비워 둔다 — 실제로 창을 막 열었을 때와 같은 모습 (2026-09-22 사용자 요청).
  //   계약 상품만 하나 골라 두는데, 그래야 수량·단위·개월 칸이 함께 보인다.
  const form = useMemo(() => ({
    company_name: '',
    phone: '',
    mobile_phone: '',
    address: '',
    memo: '',
    user_name: '',
    sales_person_name: '',
    contract_date: '',
    contract_status: 'normal',
    registrationType: 'new',
    contractProducts: ticketTypes.length ? [ticketTypes[0].name || ticketTypes[0]] : [],
    contractCounts: {},
    contractValidities: {},
    serviceProducts: [],
    serviceCounts: {},
    serviceValidities: {},
    promoItems: [],
    deliveryItems: [{ courier: '', tracking_number: '', is_return: false }],
  }), [ticketTypes]);

  const inp = () => ({ ...inputStyle, fontSize: 11, border: '1px solid var(--border)', background: 'var(--bg-card)' });

  return (
    <div className="rounded-xl border border-[var(--border)] bg-[var(--bg-subtle)] p-2.5">
      {/* 진짜 모달과 같은 검정 머리줄 */}
      <div className="flex items-center gap-2.5 rounded-t-lg bg-[#14181d] px-3 py-2.5">
        <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-white/15 text-[14px]">📋</span>
        <span className="text-[13px] font-extrabold text-white">신규 계약 직접 등록</span>
      </div>

      {/* 본문 — 실제 계약 창과 같은 부품, 같은 순서 */}
      <div
        className="flex max-h-[52vh] flex-col gap-2.5 overflow-y-auto rounded-b-lg bg-[var(--bg-card)] p-2.5"
        aria-label="계약 등록 창 미리보기"
      >
        <ContractModalSections
          cfg={config} isNew={isNew} isReorder={false} isMobile={false}
          form={form} errors={{}} setField={noop} setForm={noop} setDeliveryForm={noop}
          inp={inp} users={[]} salesPersons={[]} ticketTypes={ticketTypes}
          toggleProduct={noop} setCount={noop} setValidity={noop}
          formDesignCourier="" promotionalItemsList={[]}
          autoFocusNew={false} setAutoFocusNew={noop}
        />
      </div>

      {/* 진짜 모달과 같은 바닥줄 */}
      <div className="mt-1.5 flex justify-end gap-2 px-1">
        <span className="rounded-lg border border-[var(--border)] bg-[var(--bg-subtle)] px-3 py-1.5 text-[11.5px] font-bold text-[var(--text-sub)]">취소</span>
        <span className="rounded-lg bg-[#2563eb] px-3 py-1.5 text-[11.5px] font-bold text-white">✓  계약 등록</span>
      </div>
    </div>
  );
}
